export default function Introduction() {
  return (
    <div className="introduction">
      <h1>An overview of betamarketing</h1>
      <video controls poster="/image/poster.png">
        <source src="/image/intro.mp4" type="video/mp4" />
      </video>
    </div>
  );
}
